module.exports = __webpack_public_path__ + "img/enclosures-0.c122b525.jpeg";